import { Layout, Menu } from 'antd';
import { TeamOutlined, ShopOutlined } from '@ant-design/icons';
import { Link, Outlet, useLocation } from 'react-router-dom';

const { Sider, Content } = Layout;

export default function AdminLayout() {
  const location = useLocation();

  const selectedKey = location.pathname.startsWith('/shops')
    ? '/shops'
    : location.pathname.startsWith('/partner-shops')
    ? '/partner-shops'
    : location.pathname.startsWith('/reservations')
    ? '/reservations'
    : '/planners';

  return (
    <Layout style={{ minHeight: '100vh', background: 'white' }}>
      <Sider width={220} theme="light">
        <div
          style={{
            height: 64,
            display: 'flex',
            alignItems: 'center',
            padding: '0 20px',
            fontSize: 18,
            fontWeight: 700,
            borderBottom: '1px solid #f0f0f0',
          }}
        >
          Admin
        </div>

        <Menu
          mode="inline"
          selectedKeys={[selectedKey, location.pathname]}
          openKeys={['/reservations']}
          items={[
            {
              key: '/planners',
              icon: <TeamOutlined />,
              label: <Link to="/planners">플래너 관리</Link>,
            },
            {
              key: '/shops',
              icon: <ShopOutlined />,
              label: <Link to="/shops">드레스샵 관리</Link>,
            },
            {
              key: '/partner-shops',
              icon: <ShopOutlined />,
              label: <Link to="/partner-shops">인증업체 관리</Link>,
            },
            {
              key: '/reservations',
              icon: <ShopOutlined />,
              label: '예약 관리',
              children: [
                {
                  key: '/reservations/list',
                  label: <Link to="/reservations/list">예약 목록</Link>,
                  icon: <ShopOutlined />,
                },
                {
                  key: '/reservations/usage',
                  label: <Link to="/reservations/usage">슬롯 사용량</Link>,
                  icon: <ShopOutlined />,
                },
                {
                  key: '/reservations/transfer',
                  label: <Link to="/reservations/transfer">플래너 예약 이동</Link>,
                  icon: <TeamOutlined />,
                }
              ]
            },
          ]}
        />
      </Sider>

      <Layout>
        {/* <Header
          style={{
            background: '#fff',
            borderBottom: '1px solid #f0f0f0',
            padding: '0 20px',
            fontSize: 16,
            fontWeight: 600,
          }}
        >
          관리자 페이지
        </Header> */}

        <Content style={{ padding: 20, background: '#f5f5f5' }}>
          <Outlet />
        </Content>
      </Layout>
    </Layout>
  );
}
